import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { crmProspectList } from './queryKeys';
import envVars from '../../../constants/envVars';
import useQueryRequestParams from '../../../hooks/useQueryRequestParams';
const useGetCRMProspectList = (props, enabled) => {
    const additional = useQueryRequestParams();
    return useQuery({
        queryFn: () => axios.get(`${envVars.API_COMMERCE_HOSTNAME}crm/backoffice/list`, {
            ...additional,
            params: { ...props }
        }),
        queryKey: [crmProspectList, props],
        enabled
    });
};
export default useGetCRMProspectList;
